export default {
  request_promotion: "طلب عرض ترويجي مدفوع",
  products: "المنتجات",
  categories: "الفئات",

  search_product: "البحث عن منتج",
  search_product_placeholder: "ابحث عن منتج...",
  search_category: "البحث عن فئة",
  search_category_placeholder: "ابحث عن فئة...",

  select_all: "تحديد الكل",
  remove_all: "إزالة الكل",
  selected_products: "المنتجات المحددة",

  title: "العنوان",
  headline: "العنوان الرئيسي",
  description: "الوصف",

  offer_type: "نوع العرض",
  select_offer_type: "اختر نوع العرض",
  percentage: "نسبة مئوية (%)",
  flat_amount: "قيمة ثابتة",

  offer_value: "قيمة العرض",
  bid_amount: "قيمة المزايدة",
  banner_image: "صورة الإعلان (اختياري)",

  select_cities: "اختر المدن",

  start_date: "تاريخ البداية",
  end_date: "تاريخ النهاية",

  cancel: "إلغاء",
  submit_request: "إرسال الطلب",

  select_product_error: "اختر منتج واحد على الأقل",
  select_offer_error: "اختر نوع العرض",
  enter_value_error: "أدخل قيمة العرض",
  promotion_success: "تم إرسال الطلب للإدارة",
  clear_form: "هل تريد مسح النموذج؟",
  choose_file: "اختر ملف",
no_file_selected: "لم يتم اختيار ملف",
file_selected: "تم اختيار الملف",
percentage: "نسبة مئوية",
flat_amount: "مبلغ ثابت",
select_offer_type: "اختر نوع العرض",
};